import React from "react";
import { useMediaQuery } from "react-responsive";

import hv_player_api from "../../../../api/hv_player_api";
import Volume from "../../../shared/Svg/Volume";

export default ({ volume }) => {
  const isMobileDevice = useMediaQuery({
    query: "(max-width: 768px)",
  });

  return (
    <div id="volume_control" className={volume.muted ? "muted" : ""}>
      <div id="volume_percentile" className="rounded bg-light">
        <small className="mr-2">{`${volume.percentile} %`}</small>
        <input
          type="range"
          orient="vertical"
          value={volume.percentile}
          onChange={(e) => {
            hv_player_api.setVolume(e.target.value);
          }}
          min={0}
          max={100}
          className="custom-range"
          id="volume_percentile_input"
        />
      </div>
      <Volume className={`rounded-circle ${isMobileDevice ? "mr-2 ml-0" : "mx-2"}`} onClick={hv_player_api.toggleMute} muted={volume.muted} />
    </div>
  );
};
